import { StoreStyleProps, normalizePageStyle } from "./link-row"
import { DefaultStyle } from "./default-style"
import { CoverStyle } from "./cover-style"
import { BlurStyle } from "./blur-style"
import { CardStyle } from "./card-style"
import '../style.css'

export const StoreStyle = (props: StoreStyleProps) => {
    switch (normalizePageStyle(props.data.style)) {
        case 'cover':
            return <CoverStyle {...props} />
        case 'blur':
            return <BlurStyle {...props} />
        case 'card':
            return <CardStyle {...props} />
        default:
            return <DefaultStyle {...props} />
    }
}
